import React from 'react';
import styled from 'styled-components';
import { _ } from '_locales';
import { zeroPad } from 'react-countdown';
import { connect } from 'react-redux';
import images from '_images';
import Levels from './Levels';
import GameStatusIndicator from './GameStatusIndicator';
import SecondsCounter from './SecondsCounter';

/**
 * This component shows the result of user's answer for each question
 * in two situation of Good Job or Oops
 *
 */
const Feedbacks = (
  {
    currentLevel,
    modalVisible,
    doneMaterials,
    passedMaterialsCount,
    feedbackStatus,
    recycleRightData,
    windowsWidth
  }
) => {
  const FeedbackContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
  `;

  const GoodJobFeedback = styled.div`
    background-size: contain;
    background-position: center;
    width: ${({ windowsWidth }) => (windowsWidth >= 500 ? '262px' : '180px')};
    height: ${({ windowsWidth }) => (windowsWidth >= 500 ? '141px' : '97px')};
    background-image: url(${images.recycleRight.good_job_feedback});
  `;

  const OopsFeedback = styled.div`
    background-size: contain;
    background-position: center;
    width: ${({ windowsWidth }) => (windowsWidth >= 500 ? '229px' : '170px')};
    height: ${({ windowsWidth }) => (windowsWidth >= 500 ? '156px' : '117px')};
    background-image: url(${images.recycleRight.oops_feedback});
  `;

  const Feedback = styled.div`
    overflow: hidden;
    display: flex;
    padding: 5%;
    background-color: white;
    background-size: auto 100%;
    background-repeat: no-repeat;
    background-position: center center;
    max-width: 85%;
    will-change: transform;
    border-radius: 10px;
  `;

  const feedbackState = {
    wrong: (
      <FeedbackContainer className="wrong animate__animated animate__headShake">
        <OopsFeedback windowsWidth={windowsWidth} />
      </FeedbackContainer>
    ),
    correct: (
      <FeedbackContainer className="correct animate__animated animate__fadeIn">
        <GoodJobFeedback windowsWidth={windowsWidth} />
      </FeedbackContainer>
    )
  };

  return (
    <Container>
      <TopContainer>
        {/* <CloseButton src={images.recycleRight.close} /> */}
        <Title windowsWidth={windowsWidth}>
          <Arrow background="#fff">
            &#8678;
          </Arrow>
          {_('education.recycle_right')}
        </Title>
        <CountDownContainer>
          <SecondsCounter seconds={zeroPad('08')} isBeforeGame={false} windowsWidth={windowsWidth} />
          <TimerImage
            src={images.recycleRight.timer}
            windowsWidth={windowsWidth}
          />
        </CountDownContainer>
      </TopContainer>
      <Levels
        levels={recycleRightData}
        currentLevelKey={`level_${currentLevel + 1}_materials`}
        modalVisible={modalVisible}
        windowsWidth={windowsWidth}
      />
      <>
        <CardContainer>
          <Feedback windowsWidth={windowsWidth}>
            {feedbackState[feedbackStatus]}
          </Feedback>
        </CardContainer>
        <GameStatusIndicator
          totalMaterials={recycleRightData[`level_${currentLevel + 1}_materials`]}
          doneMaterials={doneMaterials}
          prevTotalMaterials={passedMaterialsCount}
          windowsWidth={windowsWidth}
        />
      </>
    </Container>
  );
};

export default connect(
  (store) => ({
    recycleRightData: store.education.recycle_right
  })
)(Feedbacks);

const Container = styled.div`
  overflow: hidden;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  min-height: calc(75vh - 40px - ${Number(window.statusBarHeight || 0)}px);
  user-select: none;
  outline: 0;
`;

const CardContainer = styled.div`
  display: flex;
  justify-content: center;
  margin: auto 0;
`;

const CountDownContainer = styled.div`
  display: flex;
  margin-left: auto;
  background-color: #5bc236;
  border-radius: 40px;
  padding: 3px 5px;
`;

const TimerImage = styled.img`
  height: ${({ windowsWidth }) => (windowsWidth >= 500 ? '25px' : '20px')};
  width: ${({ windowsWidth }) => (windowsWidth >= 500 ? '25px' : '20px')};
`;

const TopContainer = styled.div`
  padding: 0px 5px 5px 5px;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #E7ECEF;
`;

const Title = styled.div`
  display:flex;
  align-items: center;
  justify-content: center;
  font-size: ${({ windowsWidth }) => (windowsWidth >= 500 ? '18px' : '15px')};
  color: rgba(64, 64, 64, 1);
  font-weight: bold !important;
`;

const Arrow = styled.button`
  display: flex; 
  align-items: center;
  justify-content: center;
  padding: 0 5px 0 0;
  cursor: pointer;
  transition: all .3s;
  border-radius: 50%;
  border: none;
  line-height: normal;
  background-color: ${({ background }) => background} ;

  &:hover {
    border-radius: 50%;
    background-color: #EBEBF0;
    box-shadow: rgba(99, 99, 99, 0.3) 0 2px 6px 0px;
  }

  &:disabled {
     opacity: 0.3 !important;
     cursor: not-allowed;
     box-shadow: none;
  }
`;

const CloseButton = styled.img`
  height: 20px;
  width: 20px;
  border-radius: 50%;
`;
